export async function waitForSelector(
    selector: string | HTMLElement,
    options: { timeout?: number } = { timeout: 10000 }
): Promise<void> {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            let element;
            if (selector instanceof HTMLElement) {
                element = selector;
            } else if (typeof selector === 'string') {
                element = document.querySelector(selector);
            }

            if (element) {
                console.log(`Selector "${selector}" found.`);
                console.log('Element:', element);
                clearInterval(interval);
                resolve();
            }
        }, 100);
        setTimeout(() => {
            clearInterval(interval);
            reject(new Error(`Selector "${selector}" not found`));
        }, options.timeout);
    });
}
